import React from 'react';
import { useNavigate } from 'react-router';
import { notification } from 'antd';

import { useAppDispatch } from 'store';
import { MainLayout } from 'components/Layout/MainLayout';
import {
  savePurchasesItem,
  savePurchasesItemAsDraft,
} from 'store/slices/purchases/actions';
import {
  IPurchasesItem,
  TPurchasesDraftItem,
} from 'store/slices/purchases/interfaces';

import { PurchasesForm } from './components/PurchasesForm/PurchasesForm';
import { INITIAL_STATE } from './components/PurchasesForm/constants';

export const Add = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const onFinish = (values: IPurchasesItem) => {
    setIsLoading(true);
    dispatch(savePurchasesItem(values))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно создана',
        });
        navigate('/purchases');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveDraft = (values: TPurchasesDraftItem) => {
    setIsLoading(true);
    dispatch(savePurchasesItemAsDraft(values))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно создана',
        });
        navigate('/purchases');
      })
      .catch(() => setIsLoading(false));
  };

  const cancelButtonHandler = () => {
    navigate('/purchases');
  };

  return (
    <MainLayout pageTitle='Создание'>
      <PurchasesForm
        onFinish={onFinish}
        onSaveDraft={onSaveDraft}
        cancelButtonHandler={cancelButtonHandler}
        isDraft
        isLoading={isLoading}
        initialValues={INITIAL_STATE}
      />
    </MainLayout>
  );
};
